import type { AxiosResponse } from 'axios';

import { Camelize, camelize, NonRecursiveCamelize } from './object-utilities';

/**
 * Intended to be an implementation-agnostic wrapper for network responses
 * Hopefully this helps us smooth the transition from axios to fetch
 */
export default class HttpResponse<SnakeCaseAPIResponseType> {
  rawResponse: AxiosResponse<SnakeCaseAPIResponseType>;

  body: NonRecursiveCamelize<SnakeCaseAPIResponseType> | Camelize<SnakeCaseAPIResponseType>;

  constructor(rawResponse: AxiosResponse<SnakeCaseAPIResponseType>) {
    this.rawResponse = rawResponse;
    this.body = camelize(rawResponse.data, true);
  }
}
